<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    class="core-navigation-drawer"
    :value="$store.state.drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    :src="barImage"
    mobile-break-point="960"
    app
    mini-variant-width="0"
    :width="expandOnHover && !$vuetify.breakpoint.smAndDown ? 80 : 260"
    v-bind="$attrs"
    @input="(val) => $store.commit('SET_DRAWER', val)"
  >
    <template #img="props">
      <v-img :gradient="`to bottom, ${barColor}`" v-bind="props" />
    </template>
    <v-list-item two-line>
      <v-list-item-content>
        <v-img
          :src="require('@/assets/logo.png')"
          min-width="50"
          max-width="60%"
        />
      </v-list-item-content>
    </v-list-item>
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title class="text-uppercase font-weight-regular display-2">
          <!-- <span class="logo-mini">{{ $t('ct') }}</span> -->
          <span class="logo-normal">{{ $t('title') }}</span>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider class="mb-2" />

    <v-list expand nav>
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />

      <v-treeview
        v-if="textbookMenuItems[0] && textbookMenuItems[0].children"
        v-model="tree"
        class="mb-4"
        :open.sync="open"
        :items="textbookMenuItems"
        :active="activeTree"
        item-key="id"
        item-children="children"
        activatable
        :multiple-active="false"
        return-object
        @update:active="
          (val) => {
            if (!val.length) {
              triggerUpdateToggle = !triggerUpdateToggle
              return
            }
            const newRoute = val.pop().to
            if (
              !($route.params.textbookIssueId &&
              $route.params.textbookIssueId === newRoute.params
                ? newRoute.params.textbookIssueId
                : '')
            ) {
              if (
                $route.params.textbookIssueId &&
                $route.params.textbookIssueId ===
                  newRoute.params.textbookIssueId
              ) {
                return
              }
              $router.push(newRoute)
            }
          }
        "
      >
        <template #prepend="{ item: slotItem }">
          <v-icon>
            {{ slotItem.icon }}
          </v-icon>
        </template>
        <template #label="{ item: slotItem }">
          <v-tooltip top v-if="!!slotItem.tooltip">
            <template #activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <router-link
                  :to="slotItem.to"
                  event=""
                  class="navigation-link"
                  @click.native.prevent="() => {}"
                  >{{ slotItem.name }}</router-link
                >
                <v-avatar
                  v-if="slotItem.children"
                  class="ml-4"
                  size="20"
                  color="grey"
                  v-text="slotItem.children.length ? slotItem.children.length : 0"
                />
              </div>
            </template>
            <span v-text="slotItem.tooltip" />
          </v-tooltip>
          <template v-else>
            <router-link
                :to="slotItem.to"
                event=""
                class="navigation-link"
                @click.native.prevent="() => {}"
                >{{ slotItem.name }}</router-link
              >
              <v-avatar
                  v-if="slotItem.children"
                  class="ml-4"
                  size="20"
                  color="grey"
                  v-text="slotItem.children.length ? slotItem.children.length : 0"
                />
          </template>
        </template>
      </v-treeview>
      <!-- <base-item
            v-else
            :key="`group-${i}`"
            :item="{
              ...textbookMenuItems,
              title: textbookMenuItems.name,
            }"
          /> -->
      <template v-for="(item, i) in computedItems">
        <template v-if="item.show">
          <base-item-group
            v-if="item.children"
            :key="`group-${i}`"
            :item="item"
          >
            <!--  -->
          </base-item-group>

          <base-item v-else :key="`item-${i}`" :item="item" />
        </template>
      </template>

      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />
    </v-list>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import {
  defineComponent,
  ref,
  computed,
  watch,
  onBeforeMount,
} from '@vue/composition-api'
import { useStore as useTextbookStore } from '@/shared/state-management/textbookStore'
import { useStore as useUserStore } from '@/shared/state-management/userStore'
import {
  VIEW_USER_MANAGEMENT,
  VIEW_LICENSE_MANAGEMENT,
} from '@/shared/user/permissions'
import barImage from '@/assets/sidebar-1.jpg'

export default defineComponent({
  name: 'DashboardCoreDrawer',

  props: {
    expandOnHover: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { root, emit }) {
    const tree = ref([])
    const open = ref([])
    const triggerUpdateToggle = ref(false)
    const { textbooks, loading } = useTextbookStore().getters
    const { hasPermissionTo } = useUserStore().getters
    const textbookMenuItems = computed(() => {
      const children = textbooks.value.map((textbook) => ({
        name: textbook.name,
        id: textbook.id,
        to: { name: 'TextbookIssues', params: { textbookId: textbook.id } },
        icon: 'mdi-book-open-variant',
        children: textbook.issues.map((issue) => ({
          name: issue.name,
          tooltip: `${issue.isbn}, ${issue.name}`,
          id: issue.id,
          to: {
            name: 'TextbookIssuePages',
            params: { textbookId: textbook.id, textbookIssueId: issue.id },
          },
          icon: 'mdi-book-open-page-variant',
        })),
      }))
      const textbookMenuItem = [
        {
          name: root.$t('textbooks.title'),
          icon: 'mdi-bookshelf',
          to: { name: 'Textbooks', params: {} },
          id: 'asfsdfadsf',
          children,
        },
      ]

      return children.length ? [...textbookMenuItem] : textbookMenuItem
    })

    const initOpen = () => {
      const newOpen = [...open.value]
      const activeTextbookId = root.$route.params.textbookId
      const activeTextbookIssueId = root.$route.params.textbookIssueId

      if (root.$route.name === textbookMenuItems.value[0].to.name) {
        return
      }

      if (!activeTextbookId) {
        return
      }

      if (
        activeTextbookId &&
        !newOpen.some((el) => el.id === textbookMenuItems.value[0].id)
      ) {
        newOpen.push(textbookMenuItems.value[0])
      }

      if (
        activeTextbookIssueId &&
        !newOpen.some((el) => el.id === activeTextbookId)
      ) {
        newOpen.push({ id: activeTextbookId })
      }

      open.value = [...newOpen]
    }

    const activeTree = computed(() => {
      if (root.$route.name === textbookMenuItems.value[0].to.name) {
        return triggerUpdateToggle.value
          ? [textbookMenuItems.value[0]]
          : [textbookMenuItems.value[0]]
      }
      const activeTextbookId = root.$route.params.textbookId
      const activeTextbookIssueId = root.$route.params.textbookIssueId
      if (!(activeTextbookId || activeTextbookIssueId)) {
        return triggerUpdateToggle.value ? [] : []
      }
      if (activeTextbookIssueId) {
        return triggerUpdateToggle.value
          ? [{ id: activeTextbookIssueId }]
          : [{ id: activeTextbookIssueId }]
      }
      if (activeTextbookId) {
        return triggerUpdateToggle.value
          ? [{ id: activeTextbookId }]
          : [{ id: activeTextbookId }]
      }
    })

    watch(() => loading.value, initOpen)

    onBeforeMount(initOpen)

    const items = ref([
      {
        icon: 'mdi-account-multiple',
        title: 'menu.users',
        to: '/users',
        permission: VIEW_USER_MANAGEMENT,
      },
      {
        icon: 'mdi-card-account-details',
        title: 'menu.licenses',
        to: '/licenses',
        permission: VIEW_LICENSE_MANAGEMENT,
      },
    ])

    const barColor = 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)'

    const mapItem = (item) => {
      return {
        ...item,
        children: item.children ? item.children.map(mapItem) : undefined,
        title: root.$t(item.title),
        show: item.permission ? hasPermissionTo.value(item.permission) : true,
      }
    }

    const computedItems = computed(() => items.value.map(mapItem))

    watch(
      () => root.$vuetify.breakpoint.smAndDown,
      (val) => {
        emit('update:expandOnHover', !val)
      }
    )

    return {
      items,
      barColor,
      barImage,
      computedItems,
      activeTree,
      tree,
      open,
      textbookMenuItems,
      triggerUpdateToggle,
    }
  },
})
</script>
<style lang="scss">
.core-navigation-drawer {
  .v-treeview-node__label {
    color: #fff !important;
  }

  .navigation-link {
    text-decoration: none;
    color: inherit;
  }

  .v-treeview-node {
    cursor: pointer;
    &__root,
    &__leaf {
      transition: background-color ease-in 0.3s;
      &:hover {
        background-color: #333a;
      }
    }
  }

  .v-treeview-node--active {
    background-color: #043465 !important;
  }

  .v-list-item--active::before {
    opacity: 0;
  }

  .v-treeview-node__level {
    width: 12px;
  }
}
</style>
<style lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'

#core-navigation-drawer
  &.v-navigation-drawer--mini-variant
    .v-list-item
      justify-content: flex-start !important

    .v-list-group--sub-group
      display: block !important

  .v-list-group__header.v-list-item--active:before
    opacity: .24

  .v-list-item
    &__icon--text,
    &__icon:first-child
      justify-content: center
      text-align: center
      width: 20px

      +ltr()
        margin-right: 24px
        margin-left: 12px !important

      +rtl()
        margin-left: 24px
        margin-right: 12px !important

  .v-list--dense
    .v-list-item
      &__icon--text,
      &__icon:first-child
        margin-top: 10px

  .v-list-group--sub-group
    .v-list-item
      +ltr()
        padding-left: 8px

      +rtl()
        padding-right: 8px

    .v-list-group__header
      +ltr()
        padding-right: 0

      +rtl()
        padding-right: 0

      .v-list-item__icon--text
        margin-top: 19px
        order: 0

      .v-list-group__header__prepend-icon
        order: 2

        +ltr()
          margin-right: 8px

        +rtl()
          margin-left: 8px
</style>
